let isSigninRequired: boolean | undefined;

export function getIsSigninRequiredForTelemetry(): boolean | undefined {
    return isSigninRequired;
}

export function setIsSigninRequiredForTelemetry(isSigninNeeded: boolean | undefined): void {
    isSigninRequired = isSigninNeeded;
}
